/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivCreateSignDtoGen,
  MrfiktivPopulatedSnapshotSignRequestViewModelGen,
  MrfiktivSnapshotSignResponseControllerAcceptParamsGen,
  MrfiktivSnapshotSignResponseControllerGetParamsGen,
  MrfiktivSnapshotSignResponseControllerRejectParamsGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class HandoverSnapshotSignResponse<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags handover-snapshot-sign-response
   * @name SnapshotSignResponseControllerGet
   * @summary (SCT) Get a snapshot
   * @request GET:/partner/{partnerId}/snapshot-sign-response/{signRequestId}
   * @secure
   * @response `200` `MrfiktivPopulatedSnapshotSignRequestViewModelGen` The found record
   * @response `400` `void` Bad Request.
   * @response `403` `void` Forbidden.
   * @response `404` `void` Snapshot not found.
   */
  snapshotSignResponseControllerGet = (
    { partnerId, signRequestId, ...query }: MrfiktivSnapshotSignResponseControllerGetParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPopulatedSnapshotSignRequestViewModelGen, void>({
      path: `/partner/${partnerId}/snapshot-sign-response/${signRequestId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags handover-snapshot-sign-response
   * @name SnapshotSignResponseControllerAccept
   * @summary (sct) Accepts snapshot sign request
   * @request PATCH:/partner/{partnerId}/snapshot-sign-response/{signRequestId}/accept
   * @secure
   * @response `201` `MrfiktivPopulatedSnapshotSignRequestViewModelGen` The updated snapshot
   */
  snapshotSignResponseControllerAccept = (
    { partnerId, signRequestId, ...query }: MrfiktivSnapshotSignResponseControllerAcceptParamsGen,
    data: MrfiktivCreateSignDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPopulatedSnapshotSignRequestViewModelGen, any>({
      path: `/partner/${partnerId}/snapshot-sign-response/${signRequestId}/accept`,
      method: "PATCH",
      query: query,
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags handover-snapshot-sign-response
   * @name SnapshotSignResponseControllerReject
   * @summary (sct) Rejects snapshot sign request
   * @request PATCH:/partner/{partnerId}/snapshot-sign-response/{signRequestId}/reject
   * @secure
   * @response `201` `MrfiktivPopulatedSnapshotSignRequestViewModelGen` The updated snapshot
   */
  snapshotSignResponseControllerReject = (
    { partnerId, signRequestId, ...query }: MrfiktivSnapshotSignResponseControllerRejectParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPopulatedSnapshotSignRequestViewModelGen, any>({
      path: `/partner/${partnerId}/snapshot-sign-response/${signRequestId}/reject`,
      method: "PATCH",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
}
